import React from "react";

const ExportCsvButton = ({
  onClick,
  disabled = false,
  className = "",
  type = "button",
}) => (
  <button
    type={type}
    className={`np-export-csv-button ${className}`.trim()}
    onClick={onClick}
    disabled={disabled}
  >
    <svg
      aria-hidden="true"
      className="np-export-csv-icon"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M12 3v11m0 0 4-4m-4 4-4-4M5 15v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4" />
    </svg>
    <span>Export CSV</span>
  </button>
);

export default ExportCsvButton;
